export default "/images/check-square.svg?6ffba6b563ca941808da8ba3faf7f77d";